import React from "react";

import { Contants } from "components/constants";
import Share from "components/share";
import parser from "html-react-parser";
import moment from "moment";

import { Agenda } from "../../../../data/interfaces";
import {
  Container,
  ContainerPerson,
  Nome,
  Especialidade,
  Image,
  ContainerDados,
  Label,
  Informacao,
  Curriculo,
  Action,
  BoxImage,
  ContainerBoxImage,
  ContainerBoxText,
} from "./styles";

interface OwnProps {
  cadastro: Agenda;
}

type Props = OwnProps;

export default function Detalhe({ cadastro }: Props) {
  return (
    <Container>
      <ContainerBoxImage>
        <BoxImage>
          <Image src={cadastro.urlImage} alt="Foto" />
        </BoxImage>
        <ContainerBoxText>
          <Image src={cadastro.urlImage} alt="Foto" />
          <Share
            link={`${Contants.LINK_SHARE}/evento/${cadastro.key}/1`}
            titulo={cadastro.descricao}
          />
        </ContainerBoxText>
      </ContainerBoxImage>
      <ContainerPerson>
        <ContainerDados>
          <Nome>{cadastro.tipo}</Nome>
          <Especialidade>
            {moment(cadastro.data).format("DD-MM-YYYY")}
          </Especialidade>
          <Label>{cadastro.descricao}</Label>
          <Action
            href={cadastro.link}
            rel="noreferrer noopener"
            target="_blank"
          >
            <Label>{cadastro.link}</Label>
          </Action>
        </ContainerDados>
      </ContainerPerson>
      <Informacao>Informações</Informacao>
      <Curriculo>
        {cadastro.texto !== undefined && cadastro.texto !== null
          ? parser(cadastro.texto)
          : ""}
      </Curriculo>
    </Container>
  );
}
